import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    creatTestRateCard as creatTestRateCardApi,
    updateTestRateCard as updateTestRateCardApi,
    getAllTestRateCards as getAllTestRateCardsApi,
    getTestRateCard as getTestRateCardApi,
} from './api';

// actions
import { testRateCardApiResponseSuccess, testRateCardApiResponseError } from './actions';

// constants
import { TestRateCardActionTypes } from './constants';

type TestRateCardData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Test Rate Card
 * @param {*}
 */
function* addTestRateCard({ payload, type }: TestRateCardData): SagaIterator {
    try {
        const response = yield call(creatTestRateCardApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                testRateCardApiResponseSuccess(
                    TestRateCardActionTypes.ADD_TEST_RATE_CARD,
                    data,
                    'Test Rate Card has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating Test Rate Card!`;
            if (message) msg = message;
            yield put(
                testRateCardApiResponseSuccess(TestRateCardActionTypes.ADD_TEST_RATE_CARD, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(
            testRateCardApiResponseError(TestRateCardActionTypes.ADD_TEST_RATE_CARD, [], error, 404, true, false)
        );
    }
}

/**
 * Edit Test Rate Card
 * @param {*}
 */
function* editTestRateCard({ payload, type }: TestRateCardData): SagaIterator {
    try {
        const response = yield call(updateTestRateCardApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                testRateCardApiResponseSuccess(
                    TestRateCardActionTypes.EDIT_TEST_RATE_CARD,
                    data,
                    'Test Rate Card Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit Test Rate Card!`;
            if (message) msg = message;
            yield put(
                testRateCardApiResponseSuccess(
                    TestRateCardActionTypes.EDIT_TEST_RATE_CARD,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            testRateCardApiResponseError(TestRateCardActionTypes.EDIT_TEST_RATE_CARD, [], error, 404, true, false)
        );
    }
}

/**
 * Get Test Rate Card
 * @param {*}
 */
function* getTestRateCard({ payload, type }: TestRateCardData): SagaIterator {
    try {
        const response = yield call(getTestRateCardApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                testRateCardApiResponseSuccess(
                    TestRateCardActionTypes.GET_TEST_RATE_CARD,
                    data,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Test Rate Card!`;
            if (message) msg = message;
            yield put(
                testRateCardApiResponseSuccess(TestRateCardActionTypes.GET_TEST_RATE_CARD, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(
            testRateCardApiResponseError(TestRateCardActionTypes.GET_TEST_RATE_CARD, [], error, 404, true, false)
        );
    }
}

/**
 * Get Test Rate Cards
 * @param {*}
 */
function* getTestRateCards({ payload, type }: TestRateCardData): SagaIterator {
    try {
        const response = yield call(getAllTestRateCardsApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                testRateCardApiResponseSuccess(
                    TestRateCardActionTypes.GET_TEST_RATE_CARDS,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Test Rate Cards Listing!`;
            if (message) msg = message;
            yield put(
                testRateCardApiResponseSuccess(
                    TestRateCardActionTypes.GET_TEST_RATE_CARDS,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            testRateCardApiResponseError(TestRateCardActionTypes.GET_TEST_RATE_CARDS, [], error, 404, true, false)
        );
    }
}

export function* watchAddTestRateCard() {
    yield takeEvery(TestRateCardActionTypes.ADD_TEST_RATE_CARD, addTestRateCard);
}

export function* watchEditTestRateCard() {
    yield takeEvery(TestRateCardActionTypes.EDIT_TEST_RATE_CARD, editTestRateCard);
}

export function* watchGetTestRateCard(): any {
    yield takeEvery(TestRateCardActionTypes.GET_TEST_RATE_CARD, getTestRateCard);
}

export function* watchGetTestRateCards(): any {
    yield takeEvery(TestRateCardActionTypes.GET_TEST_RATE_CARDS, getTestRateCards);
}

function* testRateCardSaga() {
    yield all([
        fork(watchAddTestRateCard),
        fork(watchEditTestRateCard),
        fork(watchGetTestRateCard),
        fork(watchGetTestRateCards),
    ]);
}

export default testRateCardSaga;
